<template>
<v-select
  @change="handleTeamChange($event)"
  :value="value"
  :items="clubs"
  :loading="loading_clubs"
  item-text="club_name"
  item-value="id"
  placeholder="Kaikki joukkueet"
  clearable
  :style="`max-width: ${width || '300px'};`"
>
  <!-- How the selected item appears in the input -->
  <template #selection="{ item }">
    <div class="d-flex align-center">
      <v-img
        v-if="item && item.small_logo_url"
        :src="item.small_logo_url"
        width="20"
        height="15"
        contain
        class="mr-2"
      />
      <span v-if="item">{{ item.club_name }}</span>
    </div>
  </template>

  <!-- How each item appears in the list dropdown -->
  <template #item="{ item, attrs, on }">
    <!-- Important: pass v-bind="attrs" and v-on="on" so Vuetify can handle clicks -->
    <v-list-item
      v-if="item"
      v-bind="attrs"
      v-on="on"
    >
      <v-list-item-avatar>
        <v-img
          :src="item.small_logo_url"
          width="40"
          height="40"
          contain
        />
      </v-list-item-avatar>
      <v-list-item-title>
        {{ item.club_name }}
      </v-list-item-title>
    </v-list-item>
  </template>
</v-select>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  props: ['value', 'variant', 'width'],
  created() {
    this.initClubs(this.currentTeam.league_id);
  },
  methods: {
    ...mapActions('admin', [
      'initClubs',
    ]),
    handleTeamChange(teamId) {
      this.$emit('input', teamId)
    }
  },
  computed: {
    ...mapGetters('admin', [
      'clubs',
      'loading_clubs'
    ]),
    ...mapGetters('user', [
      'currentTeam'
    ]),
  }
}
</script>